<template>
  <div class="bg-image">
    <div class="row g-0 justify-content-center bg-primary-dark-op">
      <div
        class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0"
      >
        <!-- Sign Up Block -->
        <div
          class="block block-transparent block-rounded w-100 mb-0 overflow-hidden"
        >
          <div
            class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-body-extra-light"
          >
            <!-- Header -->
            <div class="mb-2 text-center">
              <a class="link-fx fw-bold fs-1" to="home">
                <span class="text-dark">Save</span
                ><span class="text-primary">Control</span>
              </a>
              <p class="text-uppercase fw-bold fs-sm text-muted">
                Crear Nueva Cuenta
              </p>
            </div>
            <div>
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nombre"
                    v-model="data.user.name"
                  />
                  <span class="input-group-text">
                    <i class="fa fa-user-circle"></i>
                  </span>
                </div>
              </div>
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="email"
                    class="form-control"
                    id="signup-email"
                    placeholder="Email"
                    v-model="data.user.email"
                  />
                  <span class="input-group-text">
                    <i class="fa fa-envelope-open"></i>
                  </span>
                </div>
              </div>
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="password"
                    class="form-control"
                    id="signup-password"
                    placeholder="Contraseña"
                    v-model="data.user.password"
                  />
                  <a
                    class="btn btn-outline-secondary"
                    id="togglePassword"
                    @click="showPassword('signup-password', 'toggleIconRegister')"
                  >
                    <i class="fa fa-eye" id="toggleIconRegister"></i>
                  </a>
                </div>
              </div>
              <div class="mb-4"></div>
              <div class="text-center mb-4">
                <button
                  type="submit"
                  class="btn btn-hero btn-primary"
                  @click="check_form()"
                >
                  <i class="fa fa-fw fa-plus opacity-50 me-1"></i> Registrar
                </button>
              </div>
            </div>
            <!-- END Sign Up Form -->
          </div>
        </div>
      </div>
      <!-- END Sign Up Block -->
    </div>

    <!-- Terms Modal -->
    <div
      class="modal fade"
      id="modal-terms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-terms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="block block-themed block-transparent mb-0">
            <div class="block-header bg-success">
              <h3 class="block-title">Terms &amp; Conditions</h3>
              <div class="block-options">
                <button
                  type="button"
                  class="btn-block-option"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content block-content-full text-end bg-body">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                data-bs-dismiss="modal"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Terms Modal -->
  </div>
</template>

<script setup>
import useRegister from "@/composables/useRegister";
const { data, check_form, showPassword } = useRegister();
</script>
